/**
 * Created with IntelliJ IDEA.
 * created by saltrichter
 *
 * Controller is responsible to display the NotificationView in Expanded Container
 */

define(function (require) {
    "use strict";
    var LE = require("app");

    var NotificationView = require("connection-views/notificationTab/NotificationView");
    var NotificationModel = require("connection-models/notificationTab/NotificationModel");
    var UserModel = require("models/entities/UserModel");
    var CP_CONST = require("connection-const");
    var NotificationViewController = {};
    LE.module('LEConnection', function (LEConnection, LE, Backbone, Marionette, $, _) {
        NotificationViewController = Marionette.Controller.extend({

            referrerAction: "notificationTest",
            dataInitialized: false,

            initialize: function (options) {
                this.channel = options.notificationViewControllerChannel || {vent: {}};
                this.notificationTabChannel = options.channel || {vent: {}};
                this.contentContainerChannel = options.containerChannel || {vent: {}};
                this.notificationsCollection = options.notificationsCollection || {};
                this._bindEvents();
                LEConnection.logger.debug("NotificationViewController.initialize: initialized NotificationViewController");
            },

            _bindEvents: function () {
                this.listenTo(this.channel.vent, "NotificationViewController::notification:display", this._displayNotification);
                this.listenTo(this.channel.vent, "NotificationViewController::notification:remove", this._removeNotification);
                this.listenTo(this.channel.vent, "NotificationViewController::window:close", this._closeView);
                LEConnection.logger.debug("NotificationViewController._bindEvents: successfully binded all events");
            },

            _refreshView: function () {
                this.NotificationView = new NotificationView({model: this.model, channel: this.channel});
                this._displayView({view: this.NotificationView});
                LEConnection.logger.debug("NotificationViewController._refreshView: refreshed view");
            },

            _displayView: function (options) {
                this.contentContainerChannel.vent.trigger("NotificationExtendedContainerController::container:displayNotificationView", options);
                LEConnection.logger.debug("NotificationViewController._displayView: triggered display view");
            },

            _closeView: function () {
                this.notificationTabChannel.vent.trigger("NotificationTabController::notificationView:close");
                LEConnection.logger.debug("NotificationViewController._closeView: triggered close view");
            },

            _removeNotification: function (model) {
                this.notificationTabChannel.vent.trigger("NotificationTabController::notification:remove", model, true);
                LEConnection.logger.debug("NotificationViewController._removeNotification: triggered remove Notification");
            },

            _displayNotification: function (model) {
                var options = {};
                options.channel = this.channel;
                options.model = model;
                this.model = model;
                this.NotificationView = new NotificationView(options);
                options.view = this.NotificationView;
                this._displayView(options);
                LEConnection.logger.debug("NotificationViewController._displayNotification: successfully initiated the display notification call");
            }
        });
    });
    return NotificationViewController;
});


